<div class="grid-container text-align-center no-padding">
    <div class="grid-x">
        <div class="cell medium-12 canvas-cell-container relative">
            <h2 class="detail-index">{{segmentIndex + 1}}</h2>
            <section class="canvas-container">
                <canvas #canvas id="canvas" height="600" width="735"></canvas>
            </section>
        </div>       
    </div>
</div>
